import { render } from "./TestObject.vue?vue&type=template&id=1d669ca6&scoped=true"
import script from "./TestObject.vue?vue&type=script&lang=js"
export * from "./TestObject.vue?vue&type=script&lang=js"

import "./TestObject.vue?vue&type=style&index=0&id=1d669ca6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d669ca6"]])

export default __exports__